export default __webpack_public_path__ + "static/media/WMETIS.95296636.svg";